import { Color } from 'src/types/gifts'

const colorByCode: Record<Color, string> = {
  [Color.UI_FEEDBACK_SUCCESS]: 'green',
  [Color.UI_TEXT_PRIMARY]: 'dark',
  [Color.UI_TEXT_INVERTED]: 'white'
}

export const getColor = (colorName: Color): string => {
  return colorByCode[colorName]
}
